import {
  type ConfigLoader,
  type GrowthBookSourceInitSettings,
  type GrowthBookSourceUpdateSettings,
} from '../lib/loader';
import { type FrontendConfigurationSchema } from '../generated/frontend';
import { type GrowthBookSchema } from '../generated/growthBook';
import { getFrontendConfig, getGrowthBookConfig } from './store';

const getConfigLoader = <T>(config: { loader?: T }, configName: string): T => {
  if (config.loader === undefined) {
    throw new Error(`No ${configName} config loader was found`);
  }
  return config.loader;
};

export const getFrontendConfigLoader =
  (): ConfigLoader<FrontendConfigurationSchema> =>
    getConfigLoader(getFrontendConfig(), 'frontend');

export const getGrowthBookConfigLoader = (): ConfigLoader<
  GrowthBookSchema,
  GrowthBookSourceInitSettings,
  GrowthBookSourceUpdateSettings
> => getConfigLoader(getGrowthBookConfig(), 'growthBook');
